import script from "./OrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=4f7a5a73&scoped=true&lang=less"
import "./OrderList.vue?vue&type=style&index=1&id=4f7a5a73&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7a5a73"]])

export default __exports__